import { NavLink, Link } from "react-router-dom";
import { Users, Target, ListChecks, MessageSquare, HeartHandshake, Home, FileBarChart, Sparkles } from "lucide-react";

const TABS = [
    { to: "/household",                  label: "Overview",     icon: Users,        end: true, testid: "hh-nav-overview" },
    { to: "/household/goals",            label: "Goals",        icon: Target,       testid: "hh-nav-goals" },
    { to: "/household/tasks",            label: "Tasks",        icon: ListChecks,   testid: "hh-nav-tasks" },
    { to: "/household/money-map",        label: "Money Map",    icon: Home,         testid: "hh-nav-money-map" },
    { to: "/household/reviews",          label: "Reviews",      icon: MessageSquare,testid: "hh-nav-reviews" },
    { to: "/household/checkin",          label: "Check-In",     icon: HeartHandshake, testid: "hh-nav-checkin" },
    { to: "/household/family-review",    label: "Family Review",icon: Home,         testid: "hh-nav-family" },
    { to: "/household/summary",          label: "Summary",      icon: FileBarChart, testid: "hh-nav-summary" },
    { to: "/household/onboarding",       label: "Onboarding",   icon: Sparkles,     testid: "hh-nav-onboarding" },
];

export default function HouseholdNav() {
    return (
        <div className="mb-6 border-b border-stone-200 sticky top-0 bg-white/95 backdrop-blur z-10 -mx-6 md:-mx-8 px-6 md:px-8" data-testid="household-nav">
            <div className="flex flex-wrap gap-1 overflow-x-auto py-2">
                {TABS.map(({ to, label, icon: Icon, end, testid }) => (
                    <NavLink key={to} to={to} end={end}
                        className={({ isActive }) =>
                            `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold transition-colors ${
                                isActive ? "bg-stone-900 text-white" : "text-stone-600 hover:bg-stone-100"
                            }`
                        }
                        data-testid={testid}>
                        <Icon size={12} /> {label}
                    </NavLink>
                ))}
                <Link to="/help/share-experience"
                      className="ml-auto inline-flex items-center gap-1 text-[11px] text-amber-800 font-semibold px-2 py-1"
                      data-testid="hh-nav-feedback">Share feedback ↗</Link>
            </div>
        </div>
    );
}
